import { createCycles } from "./modules/_";

class _App {

  constructor() {
    console.log("App", performance.now().toFixed(2));

    createCycles()
  }
}

export const App = new _App();
